import { axios } from '../../services/axios';

export default async function updateAppAuth(params, scope) {
    return axios.put(`/AppAuth/Microsoft`, params, {
        headers: {
            'X-RequestScope': scope,
        },
    });
}
